import { render, staticRenderFns } from "./BlockTimePopup.vue?vue&type=template&id=2c11e720&"
import script from "./BlockTimePopup.vue?vue&type=script&lang=ts&"
export * from "./BlockTimePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports